/**
 * FRONT-568: the live voice call (the "telephone" button) belongs on EVERY chat
 * surface inside the inbox modal — the anchor-less chat, a file opened from
 * Files, and an inbox feed item alike — not just the chat variant.
 *
 * FRONT-531 first restored the call on the chat variant after it regressed in
 * the FRONT-518 rebuild, but left assets + feed items hidden behind the same
 * `hideLiveCall` flag. This helper generalises the rule: voice is always
 * available and always binds to the surface's own session, so the turns, the
 * end-of-call recap, and the save proposal all land in that very conversation
 * (the per-asset `inbox-<id>` session for assets/feed items, the raw
 * `web:<uuid>` thread for chats). Auto-start stays opt-in — only a surface that
 * was opened via a phone button (the home launcher) requests it.
 *
 * Kept as a pure function, mirroring `resolveVoiceSessionId`, so the binding
 * rule is unit-pinned and can't silently regress back to chat-only.
 */
export interface VoiceCallBinding {
  /** Session the live voice call persists its turns/recap/save-proposal to. */
  voiceSessionId: string;
  /** Whether to hide the telephone (live voice call) button. Always false now. */
  hideLiveCall: boolean;
  /** Whether the call should auto-start once on mount. */
  autoStartCall: boolean;
}

export function voiceCallBinding(
  inboxSessionId: string,
  initialVoiceCall: boolean,
): VoiceCallBinding {
  return {
    voiceSessionId: inboxSessionId,
    hideLiveCall: false,
    autoStartCall: initialVoiceCall,
  };
}
